import React, {Component, useState} from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
import OptionsDropdown from "./OptionsDropdown";
import Axios from "axios";
import { Alert } from "react-bootstrap";
import {DropdownSort, dropdownSortOptions} from "./Hooks/SortDropdown";

export default class CampaignsTable extends Component {
    state = {
        error: null,
        alert: null,
        selectedOption:"Created",
        isAscending: false,
        sortedCampaigns: undefined,
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.campaigns !== this.props.campaigns ||
            prevState.selectedOption !== this.state.selectedOption ||
            prevState.isAscending !== this.state.isAscending
        ) {
            this.sortCampaigns();
        }
    }
    componentDidMount() {
        this.sortCampaigns();
    }

    // helper
    getValueForKey = (key, options) => {
        const option = options.find(option => option.label === key);
        return option ? option.value : null; // Return the value or null if not found
    };

    // Helper function to get nested field value
   getNestedValue = (obj, field) => {
        return field.split('.').reduce((value, key) => value[key], obj);
    };

    // Function to sort by a specific field, including nested fields
    sortByField = (arr, field, ascending = true) => {
        return arr.sort((a, b) => {
            const valueA = this.getNestedValue(a, field);
            const valueB = this.getNestedValue(b, field);
            if (valueA < valueB) return ascending ? -1 : 1;
            if (valueA > valueB) return ascending ? 1 : -1;
            return 0;
        });
    };

    sortCampaigns = () => {
            this.setState({
                sortedCampaigns: this.sortByField(
                    this.props.campaigns,
                    this.getValueForKey(this.state.selectedOption, dropdownSortOptions),
                    this.state.isAscending
                )
            })
    }

    getDropdownOptions(subfolders, parentfolder) {
        return subfolders
            .map(subfolder => ({
                name: subfolder.name,
                id: subfolder.id,
            }))
            .concat(parentfolder ? [{ name: `../${parentfolder.name}`, id: parentfolder.id }] : []);
    }

    moveCampaignToFolderAPI(campaignId) {
        return (folderId) => {
            Axios.post(process.env.REACT_APP_BACKEND_URL + "/folder/move-campaign", {
                folderId,
                campaignId,
            }).then(() => {
                this.setState({
                    alert: {
                        title: "Campaign Moved!",
                        body: "The campaign has been successfully moved to folder."
                    }
                });
                if (typeof this.props.refetchData === 'function') {
                    this.props.refetchData();
                }
            }).catch(({ response }) => {
                const errorMsg = response?.data?.message || '';
                this.setState({
                    error: {
                        title: "Error Moving to Folder!",
                        body: "Server reported an error: " + errorMsg,
                    }
                });
            });
        }
    }

    deleteCampaignAPI(campaignId) {
        return () => {
            Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/delete-campaign", {
                campaignId,
            }).then(() => {
                this.setState({
                    alert: {
                        title: "Campaign Deleted!",
                        body: "The campaign has been successfully removed."
                    }
                });
                if (typeof this.props.refetchData === 'function') {
                    this.props.refetchData();
                }
            }).catch(err => {
                this.setState({
                    error: {
                        title: "Campaign unable to be deleted!",
                        body: "Server reported an error: " + err.response?.data?.message,
                    }
                });
            });
        }
    }
    optionSelected =  (option) => {
        this.setState({selectedOption:option});
    };

    toggleOrder = () => {
        this.setState({isAscending:!this.state.isAscending});
    };
    //todo: on campaigns prop change or selectedOption or isAscending state change, re sort campaigns

    render() {
        const { subfolders, parentFolder } = this.props;
        const { error, alert } = this.state;
        const dropdownOptions = this.getDropdownOptions(subfolders, parentFolder);
        const campaigns = this.state.sortedCampaigns;

        return (
            <>
                <table className={"full-table mt-5"} cellPadding={16}>
                    <tbody>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Start - End
                            </th>
                            <th>
                                Media
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                <DropdownSort
                                    toggleOrder={this.toggleOrder}
                                    optionSelected={this.optionSelected}
                                    selectedOption={this.state.selectedOption}
                                    isAscending={this.state.isAscending}
                                />
                            </th>
                        </tr>
                        {campaigns?.length ?
                            <>
                                {campaigns.map(campaign => {
                                    return <tr key={campaign._id}>
                                        <td>
                                            <Link
                                                to={"/campaign/" + campaign._id}
                                                className={"boring-btn"}
                                            >
                                                {campaign.name}
                                            </Link>
                                        </td>
                                        <td>
                                            <i>{dateFormat(campaign.startDate, "mmm d, yyyy")} - {dateFormat(campaign.endDate, "mmm d, yyyy")}</i>
                                        </td>
                                        <td>
                                            <b>{campaign.totalBoards ? campaign.totalBoards : 0}</b>
                                        </td>
                                        <td>
                                            {(() => {
                                                if (!campaign.totalBoards) {
                                                    return <>
                                                        <div className={"error-circle"} />
                                                        No Media
                                                    </>
                                                } else if (campaign.totalBoards > campaign.boardsUploaded) {
                                                    return <>
                                                        <div className={"pending-circle"} />
                                                        Uploading - {campaign.boardsUploaded}/{campaign.totalBoards}
                                                    </>
                                                } else if (campaign.totalBoards === campaign.boardsUploaded) {
                                                    return <>
                                                        <div className={"ready-circle"} />
                                                        Ready
                                                    </>
                                                }
                                            })()}
                                        </td>
                                        <td className="d-flex justify-content-end pe-5">
                                            <OptionsDropdown
                                                options={dropdownOptions}
                                                onItemClick={this.moveCampaignToFolderAPI(campaign._id)}
                                                onDelete={this.deleteCampaignAPI(campaign._id)}
                                            />
                                        </td>
                                    </tr>
                                })}
                            </> : <></>
                        }
                    </tbody>
                </table>
                {error?.title && (
                    <Alert className="mx-auto alert-top-right w-50" variant="danger"
                        onClose={() => this.setState({ error: null })} dismissible>
                        <Alert.Heading>{error?.title}</Alert.Heading>
                        <p>{error?.body}</p>
                    </Alert>
                )}
                {alert?.title && (
                    <Alert className="mx-auto alert-top-right w-50" variant="success"
                        onClose={() => this.setState({ alert: null })} dismissible>
                        <Alert.Heading>{alert?.title}</Alert.Heading>
                        <p>{alert?.body}</p>
                    </Alert>
                )}
            </>
        )
    }
}